import {
  ADD_JOBS,
  COUNT_MESSAGES,
  ADD_DIALOGS,
  SELECT_JOB,
  JOBS_STATISTICS,
  SHOW_ASSIGNED_JOBS
} from '../Actions/jobList'

const getMyAssignedJobs = (jobs = [], myId = null) => {
  return jobs.filter(({ agents = [] }) => agents.includes(myId))
}

const JobListReducer = (state, action) => {
  const { type } = action
  switch (type) {
    case ADD_JOBS:
      return {
        ...state,
        jobs: state.showAssignedJobs ? getMyAssignedJobs(action.jobs, state.myId) : action.jobs,
        allJobs: action.jobs
      }
    case COUNT_MESSAGES:
      for (let prop in state.unreadMessages) {
        if (state.unreadMessages[prop].dialogs.includes(action.dialogId)) {
          state.unreadMessages[prop].messages = state.unreadMessages[prop].messages + 1
        }
      }
      return {
        ...state,
        unreadMessages: {
          ...state.unreadMessages
        }
      }
    case ADD_DIALOGS:
      if (state.unreadMessages[action.jobId]) {
        if (!state.unreadMessages[action.jobId].dialogs.includes(action.dialogId)) {
          state.unreadMessages[action.jobId].dialogs.push(action.dialogId)
        }
      } else {
        state.unreadMessages[action.jobId] = {
          dialogs: [action.dialogId],
          messages: 0
        }
      }
      return {
        ...state,
        unreadMessages: {
          ...state.unreadMessages
        }
      }
    case SELECT_JOB:
      return {
        ...state,
        selectedJob: action.job,
        index: action.index
      }
    case JOBS_STATISTICS:
      return {
        ...state,
        jobStatistics: action.jobStatistics
      }
    case SHOW_ASSIGNED_JOBS:
      return {
        ...state,
        myId: action.myId,
        showAssignedJobs: action.showAssignedJobs,
        jobs: action.showAssignedJobs ? getMyAssignedJobs(state.allJobs, action.myId) : state.allJobs
      }
    default:
      return state
  }
}

export default JobListReducer
